import React, { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Stamps from './pages/Stamps.jsx';
import Statistics from './pages/Statistics.jsx';
import Billing from './pages/Billing.jsx';
import ApiKeys from './pages/ApiKeys.jsx';
import Profile from './pages/Profile.jsx';
import Security from './pages/Security.jsx';
import { useCourier } from './hooks/useCourier.js';
import { auth } from './services/firebase.js';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const { stats, stamps, courierInfo, isLoading, error } = useCourier();

  const renderContent = () => {
    if (error) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <h2>Error Loading Data</h2>
          <p>{error}</p>
          <p>Please try refreshing or contact support.</p>
        </div>
      );
    }

    switch (activeTab) {
      case 'dashboard':
        return <Dashboard stats={stats} isLoading={isLoading} />;
      case 'stamps':
        return <Stamps stamps={stamps} isLoading={isLoading} />;
      case 'stats':
        return <Statistics stats={stats} isLoading={isLoading} />;
      case 'billing':
        return <Billing />;
      case 'api-keys':
        return <ApiKeys />;
      case 'profile':
        return <Profile />;
      case 'security':
        return <Security />;
      default:
        return <Dashboard stats={stats} isLoading={isLoading} />;
    }
  };

  return (
    <div className="app">
      <Sidebar
        activeTab={activeTab}
        onTabChange={setActiveTab}
        courierName={courierInfo?.name}
        userName={auth.currentUser?.email || 'User'}
        userRole="Admin"
      />
      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  );
}

export default App;